import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InvoiceLine } from '../../../models/invoice-line';

@Component({
	selector: 'app-invoice-line-detail',
	templateUrl: 'invoice-line-detail.template.html'
})

/**
 * Component for the invoiceLine detail page
 */
export class InvoiceLineDetailComponent implements OnInit
{
	invoiceId: number;
	invoiceLine: InvoiceLine;

	/**
	 * InvoiceLineDetailComponent constructor
	 *
	 * @param {ActivatedRoute} route
	 * @param {Router} router
	 */
	constructor(private route: ActivatedRoute, private router: Router)
	{
		this.invoiceId = this.route.snapshot.params['id'];
	}

	/**
	 * Lifecycle hook that is called after data-bound properties of this component are
	 * initialized.
	 */
	ngOnInit()
	{
		this.route.data.subscribe(
			(data: { invoiceLine: InvoiceLine }) => {
				this.invoiceLine = data.invoiceLine;
				this.invoiceLine.invoice_id = this.invoiceId;
			}
		);
	}

	/**
	 * Returns to the invoiceLines' invoice page
	 *
	 * @return void
	 */
	back()
	{
		this.router.navigate(['facturen', this.invoiceId])
    .then(() => {
      window.location.reload();
    });
    // let url = '/facturen';
    // this.router.navigateByUrl(url, {skipLocationChange: true}).then(()=>
    // this.router.navigate(['facturen', this.invoiceId]));
	}
}



// WEBPACK FOOTER //
// ./src/app/invoices/invoice-detail/invoice-line/invoice-line-detail.component.ts